import type { Location } from '../../../../shared/types';
import TextRenderer from './TextRenderer';

const LocationRenderer = (value: number, { locations }: { locations: Record<number, Location> }) =>
  TextRenderer(locations[value]?.title);

export default LocationRenderer;
